<div fxLayout="row" fxLayoutAlign="start start" class="overflow-x w-100">
    @for (breadcrumb of breadcrumbs; track breadcrumb; let last = $last; let index = $index) {
        <div fxLayout="row" fxLayoutAlign="start center">
            @if (!prefixPaths?.includes(breadcrumb) && !multiPathPrefix?.includes(breadcrumb)) {
                <div class="t5"
                     [class.c-primary-gray-600]="color === 'gray'"
                     [class.c-primary-green-600]="color === 'green'"
                     [class.pointer]="!last"
                     (click)="!last && navigateTo(index)">
                    @if (customizedBreadcrumbs[breadcrumb]) {
                        {{ customizedBreadcrumbs[breadcrumb] }}
                    } @else if (customLastBreadcrumb && breadcrumb === customLastBreadcrumb) {
                        {{ breadcrumb }}
                    } @else {
                        {{ 'i18n_lib_breadcrumb#' + (breadcrumb | pathFirstLetterCapitalize) | translate }}
                    }
                </div>
            }
            @if (!prefixPaths?.includes(breadcrumb) && !multiPathPrefix?.includes(breadcrumb) && !last) {
                <ui-kit-svg name="ic_arrow_right"
                            class="i-16 ml-4 mr-4 c-primary-gray-600"
                            fxFlex>
                </ui-kit-svg>
            }
        </div>
    }
</div>
